export default "__VITE_ASSET__faSPa_kT__"